<template>
  <div>
    <form role="form" @submit.stop.prevent="emitForm()">
      <div class="vx-col sm:w-3/3 w-full mb-2 card">
        <vs-card>
          <div class="vx-row">
            <div
              v-if="this.tipoInicial === 'agregado'"
              class="vx-col sm:w-1/1 w-full mb-2"
            >
              <label for="" class="vs-select--label">{{
                  'Grupo do ' + generateLabel()
                }}</label>
              <v-select
                class="w-full"
                :options="gruposAgregados"
                :name="'Grupo'"
                :id="'Grupo'"
                v-model="idGrupo"
                v-validate="{ required: true }"
                label="label"
                :state="validateState('Grupo')"
                :class="validateClass('Grupo')"
                @input="selecionaGrupoAgregado(), buscarProdutos()"
                :disabled="editarComplemento || selectGrupoDesabilitado"
              >
                <template #option="{ label, descricaoProdutos }">
                  <div style="padding-bottom: 5px">
                    <b style="margin: 0; display: block">{{ label }}</b>
                    <em v-if="descricaoProdutos" style="margin: 5px">{{
                        descricaoProdutos
                      }}</em>
                  </div>
                </template>
              </v-select>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <vs-input
                class="w-full"
                :label="'Descrição do ' + generateLabel()"
                :name="'Descrição'"
                v-model="form.descricao"
                v-validate="{ min: 3, required: true }"
                :state="validateState('Descrição')"
                :danger="validateClass('Descrição')"
              />
            </div>
          </div>

          <div v-if="this.tipoInicial !== 'implemento'" class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                class="w-full"
                :label="'Placa do ' + generateLabel()"
                v-mask="'AAA-#XX#'"
                :name="'Placa'"
                v-model="form.placa"
                v-validate="{ min: 8, required: true }"
                :state="validateState('Placa')"
                :danger="validateClass('Placa')"
                @input="keymonitorPlaca"
              />
            </div>

            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                class="w-full"
                :label="'Chassi do ' + generateLabel()"
                :name="'Chassi'"
                v-model="form.chassi"
                v-validate="{ min: 17, max: 17, required: true }"
                :state="validateState('Chassi')"
                :danger="validateClass('Chassi')"
                @input="verificaChassiBaseBP"
              />
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
      <label>{{ $t('Marca') }} {{ $t('do') }} {{ generateLabel() }}</label>
              <v-select
                :options="marcaAgregadoImplemento"
                v-model="marca"
                label="label"
                @input="selecionaMarca()"
              ></v-select>
            </div>

            <div class="vx-col sm:w-1/2 w-full mb-2">
         <label>{{ $t('Modelo') }} {{ $t('do') }} {{ generateLabel() }}</label>
              <v-select
                :options="modeloAgregadoImplemento"
                v-model="modelo"
                label="label"
                @input="selecionaModelo()"
              ></v-select>
            </div>
          </div>

          <div class="vx-row">
            <div
              class="vx-col sm:w-1/2 w-full mb-2"
              v-if="
                form.tipo === 'implemento' && this.aplicarRegraLimiteAcessorio
              "
            >
           <label for="Porcentagem da fipe" class="vs-input--label">{{ $t('Porcentagem') }} {{ $t('limite') }} {{ $t('da') }} {{ $t('Fipe') }}</label>
              <input
                type="text"
                class="w-full vs-inputx vs-input--input normal"
                name="Porcentagem limite da fipe"
                v-model="form.limiteAcessorio"
                v-validate="{ required: true }"
                :state="validateState('Porcentagem limite da fipe')"
                :danger="validateClass('Porcentagem limite da fipe')"
                :disabled="aplicarRegraLimiteAcessorio"
              />
            </div>
            <div
              class="vx-col sm:w-1/2 w-full mb-2"
              v-if="
                form.tipo === 'implemento' && this.aplicarRegraLimiteAcessorio
              "
            >
              <label for="Fipe do veiculo" class="vs-input--label"
              >Fipe do veículo principal</label
              >
              <money
                class="w-full vs-inputx vs-input--input normal"
                name="Fipe do veiculo"
                id="Fipe do veiculo"
                v-model="form.fipeVeiculo"
                v-validate="{ required: true }"
                :state="validateState('Fipe do veiculo')"
                :danger="validateClass('Fipe do veiculo')"
                v-bind="money"
                :disabled="aplicarRegraLimiteAcessorio"
                @blur.native="verificaValor()"
              ></money>
            </div>
            <div
              :class="`vx-col ${
                (exibirFormCompleto || editarComplemento) &&
                form.tipo !== 'agregado'
                  ? 'sm:w-1/2'
                  : 'sm:w-1/1'
              } w-full mb-2`"
            >
             <label for="Valor Cobertura" class="vs-input--label">{{ $t('Valor') }} {{ $t('Cobertura') }}</label>
              <money
                class="w-full vs-inputx vs-input--input normal"
                name="Valor Cobertura"
                id="Valor Cobertura"
                v-model="form.valorCobertura"
                v-validate="{ required: true }"
                :state="validateState('Valor Cobertura')"
                :danger="validateClass('Valor Cobertura')"
                v-bind="money"
                :disabled="usarValorNf"
                @blur.native="verificaValor()"
                @input="validaValorCobertura($event)"
              ></money>
            </div>
            <div
              v-if="exibirFormCompleto"
              :class="`vx-col ${
                exibirFormCompleto ? 'sm:w-1/2' : 'sm:w-1/1'
              } w-full mt-6`"
              style="display: flex; gap: 15px"
            >
              <vs-switch
                color="success"
                style="width: 60px"
                v-model="usarValorNf"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
              <span>{{ $t('Substituir') }} {{ $t('pelo') }} {{ $t('valor') }} {{ $t('da') }} {{ $t('NF') }}</span>
            </div>
          </div>

          <div
            v-if="editarComplemento && dadosComplemento.tipo == 'agregado'"
            class="vx-row"
          >
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label for="" class="vs-input--label">{{ $t('Valor') }} {{ $t('mínimo') }} {{ $t('de') }} {{ $t('participação') }}</label>
              <money
                class="w-full vs-inputx vs-input--input normal"
                name="Valor mínimo de participação"
                id="Valor mínimo de participação"
                v-model="form.valorMinimoParticipacao"
                v-validate="{ required: true }"
                :state="validateState('Valor mínimo de participação')"
                :danger="validateClass('Valor mínimo de participação')"
                v-bind="money"
              ></money>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input
                class="w-full"
                :label="`Percentual de participação`"
                name="Percentual de participação"
                v-model="form.porcentagemParticipacao"
                :state="validateState('Percentual de participação')"
                :danger="validateClass('Percentual de participação')"
              />
            </div>
          </div>

          <!-- Se substituir valor de cobertura pelo valor da NF -->
          <div class="vx-row" v-if="usarValorNf">
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <vs-input
                class="w-full"
                label="Número da nota fiscal"
                name="Número da nota fiscal"
                v-model="form.numeroNF"
                v-validate="{ min: 4 }"
                :state="validateState('Número da nota fiscal')"
                :danger="validateClass('Número da nota fiscal')"
              />
            </div>

            <div class="vx-col sm:w-1/3 w-full mb-2">
              <label for="" class="vs-select--label">{{ $t('Valor') }} {{ $t('da') }} {{ $t('NF') }}</label>
              <money
                class="w-full vs-inputx vs-input--input normal"
                name="Valor da NF"
                id="Valor da NF"
                v-model="form.valorNF"
                v-validate="{ required: true }"
                :state="validateState('Valor da NF')"
                :danger="validateClass('Valor da NF')"
                v-bind="money"
              ></money>
            </div>

            <div class="vx-col sm:w-1/3 w-full mb-2">
              <label for class="vs-input--label">{{ $t('Vencimento') }} {{ $t('da') }} {{ $t('NF') }}</label>
              <datepicker
                class="inputData"
                :format="'dd/MM/yyyy'"
                label="DD/MM/YYYY"
                v-model="form.dataNF"
                name="Data de Vencimento da Nota Fiscal"
                id="Data de Vencimento da Nota Fiscal"
                :state="validateState('Data de Vencimento da Nota Fiscal')"
                :danger="validateClass('Data de Vencimento da Nota Fiscal')"
              ></datepicker>
            </div>
          </div>

          <div
            v-if="editarComplemento && dadosComplemento.tipo == 'agregado'"
            class="vx-row"
          >
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label for="" class="vs-select--label">{{
                  `Status do ${dadosComplemento.tipo}`
                }}</label>
              <v-select
                :options="Status"
                name="Status"
                id="Status"
                v-model="statusComplementoSelecionado"
                v-validate="{ required: true }"
                label="label"
                :state="validateState('Status')"
                :class="validateClass('Status')"
                @input="selecionaStatusComplemento()"
              ></v-select>
            </div>

            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label for="" class="vs-select--label">{{ $t('Forma') }} {{ $t('de') }} {{ $t('Pagamento') }} {{ $t('Mensal') }}</label>
              <v-select
                :options="formasPagamentos"
                name="Forma de Pagamento Mensal"
                id="Forma de Pagamento Mensal"
                v-model="formaPagamentoSelecionada"
                v-validate="{ required: true }"
                label="label"
                :state="validateState('Forma de Pagamento Mensal')"
                :class="validateClass('Forma de Pagamento Mensal')"
                @input="selecionaFormaPagamento()"
              >
              </v-select>
            </div>
          </div>

          <div
            v-if="editarComplemento && dadosComplemento.tipo == 'agregado'"
            class="vx-row"
          >
            <div class="vx-col w-full mb-2">
              <vs-input
                class="w-full"
                label="Dia de Vencimento"
                v-model="form.diaVencimento"
                name="Dia de Vencimento"
                v-validate="{ required: true }"
                :state="validateState('Dia de Vencimento')"
                :danger="validateClass('Dia de Vencimento')"
              />
            </div>
          </div>

          <div
            v-if="editarComplemento && dadosComplemento.tipo == 'agregado'"
            class="vx-row"
          >
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <span>{{ $t('Participa') }} {{ $t('do') }} {{ $t('Rateio') }}?</span>
              <vs-switch
                color="success"
                v-model="form.participaRateio"
                style="width: 60px"
              >
                <span slot="on">{{ $t('Sim') }}</span>
                <span slot="off">{{ $t('Não') }}</span>
              </vs-switch>
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
             <span>{{ $t('Gera') }} {{ $t('Cobrança') }}?</span>
              <vs-switch
                color="success"
                v-model="form.geraCobranca"
                style="width: 60px"
              >
                <span slot="on">{{ $t('Sim') }}</span>
                <span slot="off">{{ $t('Não') }}</span>
              </vs-switch>
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <span>{{ $t('Boleto') }} {{ $t('Físico') }}?</span>
              <vs-switch
                color="success"
                v-model="form.boletoFisico"
                style="width: 60px"
              >
                <span slot="on">{{ $t('Sim') }}</span>
                <span slot="off">{{ $t('Não') }}</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <vs-textarea label="Observações" v-model="form.observacao"/>
            </div>
          </div>
        </vs-card>
        <vs-alert
          v-if="$validator.errors.all().length > 0"
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
        >
          <ul>
            <li
              class="mb-2"
              v-for="error in $validator.errors.all()"
              :key="error.id"
            >
              {{ error }}
            </li>
          </ul>
        </vs-alert>
      </div>

      <div v-if="this.form.tipo === 'agregado'" class="vx-row">
        <div
          class="vx-col sm:w-1/2 w-full mb-2"
          v-if="dadosComplemento.produtosAgregado"
        >
          <h5 class="mt-3 mb-6 text-center">{{ $t('Produtos') }} {{ $t('Atuais') }}</h5>
          <hr/>
          <vs-list>
            <vs-list-header
              v-if="unificarAgregados"
              :title="`Valor Cobertura Unificado: ${formataMoeda(
                valorCoberturaTotal + dadosComplemento.valorCobertura,
              )}`"
              color="green"
            ></vs-list-header>
            <vs-list-header title="Obrigatórios" color="green"></vs-list-header>
            <vs-list-item
              v-for="obrigatorio in filtraProdutosAtuais().obrigatorios"
              :key="obrigatorio.id_produto"
              :title="obrigatorio.nomeProduto"
              :subtitle="`${
                obrigatorio.descontoConcedido != 0
                  ? `de ${formataMoeda(obrigatorio.valor)}, por `
                  : ''
              }${formataMoeda(obrigatorio.valorFinal)} ${
                obrigatorio.ismensal == true ? '/mês' : ''
              }`"
            >
              <small v-if="obrigatorio.descontoConcedido"
              >{{ $t('Desconto') }}: {{ obrigatorio.descontoConcedido }}%</small
              >
            </vs-list-item>
            <vs-list-header
              v-if="filtraProdutosAtuais().opcionais.length > 0"
              title="Opcionais"
              color="blue"
            ></vs-list-header>
            <vs-list-item
              v-for="opcional in filtraProdutosAtuais().opcionais"
              :key="opcional.id_produto"
              :title="opcional.nomeProduto"
              :subtitle="`${
                opcional.descontoConcedido != 0
                  ? `de ${formataMoeda(opcional.valor)}, por `
                  : ''
              }${formataMoeda(opcional.valorFinal)} ${
                opcional.ismensal == true ? '/mês' : ''
              }`"
            >
             <small v-if="opcional.descontoConcedido"
             >{{ $t('Desconto') }}: {{ opcional.descontoConcedido }}%</small
             >
            </vs-list-item>
          </vs-list>
       <h6 class="mt-5">
         {{ $t('Total') }} {{ $t('Mensal') }}: {{ somaValorTotal(true) | currency }}
       </h6>
       <h6 class="mt-5">
         {{ $t('Total') }} {{ $t('Entrada') }}: {{ somaValorTotal(false) | currency }}
       </h6>
        </div>
        <div
          v-if="nenhumProdutoEncontrado === false"
          class="vx-col sm:w-1/2 w-full mb-2"
        >
          <h5 class="mt-3 mb-6 text-center">{{ $t('Produtos') }} {{ $t('a') }} {{ $t('serem') }} {{ $t('atualizados') }}</h5>
          <hr/>
          <vs-list-header
            v-if="unificarAgregados"
            :title="`Valor Cobertura Unificado: ${formataMoeda(
              form.valorCoberturaUnificado,
            )}`"
            color="green"
          ></vs-list-header>
          <table class="table-bordered">
            <tr>
               <th class="w-1/6"></th>
               <th class="w-2/6">{{ $t('Produto') }}</th>
               <th class="w-1/6">{{ $t('Valor') }}</th>
               <th class="w-1/6">{{ $t('Desconto') }}(%)</th>
               <th class="w-1/6">{{ $t('Valor') }} {{ $t('Final') }}</th>
              <td></td>
            </tr>
            <tr
              v-for="(item, index) in form.produtosObrigatorios"
              :key="'Obri' + index"
            >
              <td>
                <vs-checkbox
                  v-model="form.dadosProdutosSelecionados"
                  :vs-value="item"
                  :disabled="item.obrigatorio"
                  @input="selectProduct(item)"
                >
                </vs-checkbox>
              </td>
              <td>{{ item.nomeProduto }}</td>
              <td>{{ item.valor | currency }}</td>
              <td>{{ item.descontoConcedido | currency }} %</td>
              <td>{{ item.valorFinal | currency }}</td>
              <td>
                <vs-button
                  v-if="item.porcentagemDescontoMaxima"
                  radius
                  v-tooltip="'Editar Valor Final'"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  class="d-inline"
                  @click.native.prevent="abrirModalDesconto(item)"
                >%
                </vs-button
                >
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <hr class="my-3"/>
              </td>
            </tr>
            <tr
              v-for="(item, index) in form.produtosNaoObrigatorios"
              :key="'NObri' + index"
            >
              <td>
                <vs-checkbox
                  @input="selectProduct(item)"
                  v-model="form.dadosProdutosSelecionados"
                  :vs-value="item"
                >
                </vs-checkbox>
              </td>
              <td>{{ item.nomeProduto }}</td>
              <td>{{ item.valor | currency }}</td>
              <td>{{ item.descontoConcedido | currency }} %</td>

              <td>
                {{ item.valorFinal | currency }}
              </td>
              <td>
                <vs-button
                  v-if="item.porcentagemDescontoMaxima"
                  radius
                  v-tooltip="'Editar Valor Final'"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  class="d-inline"
                  @click.native.prevent="abrirModalDesconto(item)"
                >%
                </vs-button
                >
              </td>
            </tr>
          </table>

            <h6 class="mt-5">
              {{ $t('Total') }} {{ $t('Mensal') }}: {{ totalMensalidade | currency }}
            </h6>
            <h6 class="mt-5">
              {{ $t('Total') }} {{ $t('Entrada') }}: {{ totalEntrada | currency }}
            </h6>
        </div>
        <div
          v-else-if="nenhumProdutoEncontrado == true"
          class="vx-col sm:w-1/2 w-full mb-2"
        >
         <vs-alert
           title="Atenção!"
           active="true"
           color="danger"
           style="max-height: 220px !important"
         >
           {{ $t('Nenhum') }} {{ $t('produto') }} {{ $t('encontrado') }} {{ $t('para') }} {{ $t('esse') }} {{ $t('veículo') }}, {{ $t('revise') }} {{ $t('os') }} {{ $t('dados') }} {{ $t('do') }} {{ $t('veículo') }}
         </vs-alert>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <BotaoSubmit
            variant="success"
            :edit="true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>

      <vs-popup
        class="holamundo"
        :title="titleSideBar"
        :active.sync="modalDesconto"
      >
        <formDesconto
          :key="contFormDesconto"
          :produtos-selecionados="form.dadosProdutosSelecionados"
          :dados="item"
          :contador="contFormDesconto"
          :modal="modalDesconto"
          :agregado="dadosParaAplicarDesconto"
          :valorMensalidade="totalMensalidade"
          @salvarDesconto="salvaItemValor"
        >
        </formDesconto>
      </vs-popup>
    </form>
    <vs-popup
      class="holamundo"
      title="Placa Recusada"
      :active.sync="modalPlacaRecusada"
      @close="resetBuscaPlaca()"
    >
      <h5>{{ situacaoPlaca }}</h5>

     <h5 v-if="codigoSituacaoPlaca === '999'">
       {{ $t('informe') }} {{ $t('outra') }} {{ $t('placa') }} {{ $t('para') }} {{ $t('dar') }} {{ $t('continuidade') }}
     </h5>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            @click.stop.prevent="resetBuscaPlaca()"
            type="gradient"
            color="warning"
            class="mt-5"
          >
            <feather-icon
              class="text-white"
              icon="CheckIcon"
              svgClasses="h-4 w-4"
            ></feather-icon>
            {{ $t('Entendi') }}
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import locale from '../../locale';
import Datepicker from 'vuejs-datepicker';
import {Money} from 'v-money';
import vSelect from 'vue-select';
import BotaoSubmit from '../../components/BotaoSubmit';
import service from './../../services';
import formDesconto from '../forms/formDesconto.vue';
import {
  updateProdutoValorMensaliade,
  updateProdutoValorMinimoMensalidade,
} from './../../services/propostas';
import {buscarPlacaBaseBP} from '../../services/cotacao';
import functions from '../../utils/functions';
import jwt from 'jsonwebtoken';
import {decryptData} from '../../services/decryptData';

export default {
  props: [
    'dadosComplemento',
    'resetFormComplemento',
    'exibirFormCompleto',
    'grupos',
    'tipoComplemento',
    'idGrupoVeiculo',
    'idEmpresa',
    'buscarProdutoAgregado',
    'dadosCliente',
    'editarComplemento',
    'formasPagamentos',
    'dadosGerais',
    'addComplementoEdicao',
    'idRegional',
    'ativaMascarasVeiculos',
    'permitePlacaDuplicada',
    'tipoProposta',
    'unificarAgregados',
    'dadosAgregadosUnificados',
    'grupoAgregadoSelecionado',
    'precoVeiculo',
  ],
  watch: {
    tipoComplemento(value) {
      this.tipoInicial = value;
      this.form.tipo = value;
    },
    totalMensalidade: function (value) {
      if (this.totalEntrada < value) {
        this.totalEntrada = value;
      }
    },
    dadosComplemento() {
      this.preencheForm();

      this.dadosParaAplicarDesconto = {
        ...this.dadosComplemento,
        nomeGrupo: this.idGrupo.label,
      };

      if (this.unificarAgregados) {
        this.valorCoberturaTotal =
          this.dadosAgregadosUnificados.valorCoberturaTotal;
      }

      this.form.buscarProdutoAgregado = true;
      this.buscarProdutos();
    },
    usarValorNf(value) {
      if (value) this.form.valorCobertura = 0;
    },
    resetFormComplemento(value) {
      if (value) this.resetForm();
    },
    grupos(value) {
      if (!value) return;
      this.gruposAgregados = value;
    },
    'form.tipo': function (value) {
      value = this.tipoInicial;
      value === 'agregado' && this.buscaDadosGrupos();

      if (value === 'implemento') {
        this.idGrupo = null;
        this.form.idGrupo = null;
      }
    },
    marca(newVal) {
      if (!newVal) {
        this.form.modelo = null;
      }

      if (newVal && newVal.value) {
        this.getModeloAgregadoImplemento(newVal.value);
      }
    },
    grupoAgregadoSelecionado(value) {
      if (value.hasOwnProperty('idGrupo')) {
        this.buscaDadosGrupos();
      }
    },
    produtos(value) {
      if (value) this.somaValores();
    },
    dadosAgregadosUnificados: function (value) {
      if (value) {
        this.idsAgregadosUnificados = value.idsAgregadosUnificados;
        this.valorCoberturaTotal = value.valorCoberturaTotal;
      }
    },
    precoVeiculo(value) {
      this.form.fipeVeiculo = value;
    },
  },
  components: {
    Datepicker,
    Money,
    BotaoSubmit,
    'v-select': vSelect,
    formDesconto,
  },
  data() {
    return {
      formaPagamentoSelecionada: null,
      Status: [
        {id: 1, label: 'ATIVO'},
        {id: 2, label: 'INATIVO'},
        {id: 3, label: 'INADIMPLENTE'},
      ],
      modalDesconto: false,
      statusComplementoSelecionado: null,
      produtos: null,
      nenhumProdutoEncontrado: null,
      tipos: ['agregado', 'implemento'],
      gruposAgregados: [],
      idGrupo: {id: null, label: 'Selecione o grupo'},
      usarValorNf: false,
      vendedoresIniciais: [],
      titleSideBar: 'Desconto',
      item: null,
      contFormDesconto: 0,
      money: {
        decimal: '.',
        thousands: '',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
      },
      aguardeCadastro: false,
      forcarAtualizacao: false,

      tiposImplementos: [],
      marcas: [],
      modelos: [],
      modelosAux: [],

      estadoPneus: ['Ruim', 'Regular', 'Bom', 'Novo'],
      form: {
        produtosSelecionados: [],
        _preencheForm: null,
        idPropostaComplemento: null,
        idProposta: null,
        descricao: null,
        index: null,
        chassi: null,
        placa: null,
        marca: null,
        modelo: null,
        valorCobertura: 0,
        numeroNF: null,
        valorNF: null,
        dataNF: null,
        observacao: null,
        idGrupo: null,
        tipo: null,
        idRegional: null,
        limiteAcessorio: null,
      },
      totalEntrada: 0,
      totalMensalidade: 0,
      dadosParaAplicarDesconto: null,
      tipoInicial: null,
      comissaoAplicada: 0,
      valorComissaoAplicadaFinal: 0,
      placaValidada: null,
      nomeConsultorPlaca: '',
      modalPlacaRecusada: false,
      regionalConsultorPlaca: null,
      codigoSituacaoPlaca: '0',
      situacaoPlaca: '',
      marcaAgregadoImplemento: [],
      modeloAgregadoImplemento: [],
      idsAgregadosUnificados: [],
      valorCoberturaTotal: 0,
      selectGrupoDesabilitado: false,
      marca: null,
      modelo: null,
      limiteAcessorioValue: null,
      aplicarRegraLimiteAcessorio: false,
    };
  },
  methods: {
    salvaItemValor(item) {
      if (item.descontoConcedido === 0 && item.ismensal) {
        this.buscarProdutos();
        this.modalDesconto = false;
        return;
      }

      this.form.idTipoDesconto = item.idTipoDesconto;

      this.form.produtosNaoObrigatorios.forEach((element, index) => {
        if (element.id_produto == item.id_produto) {
          this.form.produtosNaoObrigatorios[index] = item;
        }
      });

      this.form.produtosObrigatorios.forEach((element, index) => {
        if (element.id_produto == item.id_produto) {
          this.form.produtosObrigatorios[index] = item;
        }
      });

      this.form.dadosProdutosSelecionados.forEach((element, index) => {
        if (element.id_produto == item.id_produto) {
          this.form.dadosProdutosSelecionados[index] = item;
        }
      });

      this.form.idTipoDesconto = item.idTipoDesconto;

      this.somaValores();
      this.modalDesconto = false;
    },
    abrirModalDesconto(item) {
      this.contFormDesconto = this.contFormDesconto + 1;
      if (item) {
        item.id = item.id_produto;
        item.estado = this.dadosCliente.estado;
        item.tipoProposta = this.dadosGerais.tipoProposta;
        item.idEmpresa = this.idEmpresa;
        this.item = item;
        this.modalDesconto = true;
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    preencheForm() {
      this.form = {
        ...this.dadosComplemento,
      };

      this.preencheMarcaModelo();

      if (!this.dadosComplemento) return;
      if (this.dadosComplemento.tipo === 'implemento') return;
      const {idComplemento, Status, idStatus, idTipoPagamentoMensal} =
        this.dadosComplemento;

      if (idComplemento) {
        const [_formaPamento] = this.formasPagamentos.filter(
          (item) => item.id == idTipoPagamentoMensal,
        );

        this.formaPagamentoSelecionada = {
          id: _formaPamento.id,
          label: _formaPamento.label,
        };

        this.statusComplementoSelecionado = {
          id: idStatus,
          label: Status,
        };
      }

      if (
        this.dadosComplemento.idGrupo &&
        (this.dadosComplemento.nomeGrupo ||
          this.dadosComplemento.nomeGrupoAgregado)
      ) {
        this.idGrupo = {
          id: this.dadosComplemento.idGrupo,
          label:
            this.dadosComplemento.nomeGrupo ||
            this.dadosComplemento.nomeGrupoAgregado,
        };
      }
    },
    resetForm() {
      this.form.idProposta = null;
      this.form.descricao = null;
      this.form.chassi = null;
      this.form.placa = null;
      this.form.marca = null;
      this.form.modelo = null;
      this.form.valorCobertura = 0;
      this.form.numeroNF = null;
      this.form.valorNf = null;
      this.form.dataNF = null;
      this.form.index = null;
      this.form.observacao = null;
      this.form.idGrupo = null;
      this.form.JsonFacilitadorProdutos = null;
      this.idGrupo = {id: null, label: 'Selecione o grupo'};
      this.produtos = null;

      this.produtos = null;
      this.form.produtosObrigatorios = null;
      this.form.produtosNaoObrigatorios = null;
      this.form.dadosProdutosSelecionados = null;
      this.form.produtosSelecionados = null;
      this.form.idPropostaComplemento = null;
      // eslint-disable-next-line vue/no-mutating-props
      this.dadosComplemento.produtosAgregado = null;
      this.nenhumProdutoEncontrado = null;
      this.placaValidada = null;
      this.form.tipo = null;
      this.nomeConsultorPlaca = '';
      this.modalPlacaRecusada = false;
      this.regionalConsultorPlaca = null;
      this.codigoSituacaoPlaca = '0';
      this.situacaoPlaca = '';
      this.marca = null;
      this.modelo = null;
    },
    resetBuscaPlaca() {
      this.nomeConsultorPlaca = '';
      this.modalPlacaRecusada = false;
      this.regionalConsultorPlaca = null;
      this.codigoSituacaoPlaca = '0';
      this.situacaoPlaca = '';
    },
    emitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.form.unificarAgregado = this.unificarAgregados;
          this.form.idsAgregadosUnificados = this.idsAgregadosUnificados;
          const _dadosComplemento = {...this.form};

          const acao =
            _dadosComplemento.index === null ? 'adicionar' : 'atualizar';

          const editarComplementoProposta =
            this.form.idPropostaComplemento && this.form.id;

          const submitForm =
            editarComplementoProposta ||
            this.editarComplemento ||
            this.addComplementoEdicao;

          if (!submitForm) {
            this.$emit(acao, _dadosComplemento);
            const textBase = this.ativaMascarasVeiculos ? this.$t(this.tipoComplemento, {msg: this.tipoComplemento}) : this.tipoComplemento;
            const text =
              acao == 'atualizar'
                ? `${textBase} Atualizado`
                : `${textBase} Adicionado`;

            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text,
              color: 'success',
            });

            this.resetForm();
          }

          if (
            editarComplementoProposta ||
            this.editarComplemento ||
            this.addComplementoEdicao
          ) {
            this.onSubmit();
          }
        } else {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Existem campos não preenchidos',
            color: 'danger',
          });
        }
      });
    },
    async onSubmit() {
      if (!this.editarComplemento) {
        if (this.form.atualizarProdutos && this.form.tipo == 'agregado') {
          this.form.produtos = this.produtos;
        } else {
          this.form.atualizarProdutos = false;
        }

        if (!this.form.marca || !this.form.modelo) {
          this.form.marca = this.marca.label;
          this.form.modelo = this.modelo.label;
        }

        const acao =
          this.addComplementoEdicao && !this.form.idPropostaComplemento
            ? 'AddComplementoEdicaoProposta'
            : 'EditarComplemento';

        if (
          acao === 'AddComplementoEdicaoProposta' &&
          this.form.tipo == 'agregado'
        ) {
          delete this.form._preencheForm;
          delete this.form.idPropostaComplemento;
          delete this.form.index;
          delete this.form.atualizarProdutos;
          delete this.form.produtosObrigatorios;
          delete this.form.produtosNaoObrigatorios;

          if (this.dadosGerais.jsonFacilitador) {
            const {
              dadosFinanceiros: {avista, mensais},
            } = JSON.parse(this.dadosGerais.jsonFacilitador);

            const [_avista] = avista;
            const [_mensais] = mensais;

            const temProdutoSelecionado =
              this.form.dadosProdutosSelecionados &&
              this.form.dadosProdutosSelecionados.length;

            if (temProdutoSelecionado) {
              this.form.dadosProdutosSelecionados.forEach((produto) => {
                if (produto.ismensal) {
                  produto.idTipoPagamentoEmpresa = _mensais
                    ? _mensais.valor.idTipoPagamentoEmpresa
                    : null;
                } else {
                  produto.idTipoPagamentoEmpresa = _avista
                    ? _avista.valor.idTipoPagamentoEmpresa
                    : null;
                }
              });
            }
          }
          this.form.idProposta = this.dadosGerais.idProposta;
        }

        if (
          acao === 'AddComplementoEdicaoProposta' &&
          this.form.tipo == 'implemento'
        ) {
          delete this.form._preencheForm;
          delete this.form.atualizarProdutos;
          delete this.form.index;

          this.form.produtosSelecionados = null;
          this.form.idProposta = this.dadosGerais.idProposta;
        }

        const {data: complemento} = await service.post(
          'Cotacao',
          acao,
          this.form,
        );

        const text =
          acao === 'EditarComplemento'
            ? `Atualizado com sucesso ${complemento.tipo}`
            : `Adicionado com sucesso ${complemento.tipo}`;

        const acaoEmit =
          acao === 'EditarComplemento' ? 'atualizar' : 'adicionar';

        this.$emit(acaoEmit, complemento);
        this.resetForm();

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text,
          color: 'success',
        });

        return;
      }
    },
    selecionaGrupoAgregado() {
      this.form.idGrupo = this.idGrupo.id;
      this.form.porcentagemParticipacao = this.idGrupo.porcentagemParticipacao;
      this.form.valorMinimoParticipacao = this.idGrupo.valorMinimoParticipacao;
      this.form.nomeGrupo = this.idGrupo.label;

      if (this.form.idGrupo !== this.dadosComplemento.idGrupo) {
        this.form.atualizarProdutos = true;
      } else if (this.form.idGrupo === undefined || this.form.idGrupo == null) {
        this.form.atualizarProdutos = true;
      } else {
        this.form.atualizarProdutos = false;
      }
    },
    async buscaDadosGrupos() {
      if (this.editarComplemento) {
        this.selecionaGrupoAgregado();
        return;
      }
      try {
        this.$vs.loading();
        const {data} = await service.getAll(
          'Grupo',
          {},
          'list/' + this.idEmpresa,
        );
        const [_grupos] = data.filter(
          ({idGrupo}) => idGrupo == this.idGrupoVeiculo,
        );
        this.gruposAgregados = JSON.parse(_grupos.gruposAgregados);
        const grupoSelecionadoAgregadosUnificados =
          this.unificarAgregados &&
          this.grupoAgregadoSelecionado.hasOwnProperty('idGrupo');
        if (grupoSelecionadoAgregadosUnificados) {
          this.idGrupo = this.gruposAgregados.find(
            ({id}) => id === this.grupoAgregadoSelecionado.idGrupo,
          );
          this.selecionaGrupoAgregado();
          this.selectGrupoDesabilitado = true;
          return;
        }
        this.idGrupo = this.gruposAgregados.find(
          ({id}) => id === this.dadosComplemento.idGrupo,
        );
      } finally {
        this.$vs.loading.close();
      }
    },
    formataProdutos(produtos) {
      const _produtos = produtos;

      const produtosObrigatorios = _produtos.filter(
        ({obrigatorio}) => obrigatorio === true,
      );
      const produtosNaoObrigatorios = _produtos.filter(
        ({obrigatorio}) => obrigatorio === false,
      );

      produtosObrigatorios.forEach((element) => {
        element.valorFinal =
          Number(element.valor) -
          (Number(element.valor) *
            Number(element.descontoConcedido ? element.descontoConcedido : 0)) /
          100;
      });

      produtosNaoObrigatorios.forEach((element) => {
        element.valorFinal =
          Number(element.valor) -
          (Number(element.valor) *
            Number(element.descontoConcedido ? element.descontoConcedido : 0)) /
          100;
      });

      const dadosProdutosSelecionados = produtosObrigatorios;

      return {
        produtosObrigatorios,
        produtosNaoObrigatorios,
        dadosProdutosSelecionados,
      };
    },
    async buscarProdutos() {
      try {
        const {tipo, idPropostaComplemento} = this.form;
        this.form.unificarAgregado = this.unificarAgregados;
        const buscarProdNovoComplemeto =
          this.addComplementoEdicao &&
          this.form.idGrupo &&
          this.form.valorCobertura;
        if (
          (tipo === 'agregado' && idPropostaComplemento) ||
          this.buscarProdutoAgregado === true ||
          buscarProdNovoComplemeto
        ) {
          this.$vs.loading();
          this.produtos = null;
          this.form.produtosObrigatorios = null;
          this.form.produtosNaoObrigatorios = null;
          this.form.dadosProdutosSelecionados = null;
          this.form.produtosSelecionados = null;
          this.form.idRegional = this.idRegional;
          this.form.valorCoberturaUnificado =
            this.valorCoberturaTotal + this.form.valorCobertura;

          if (buscarProdNovoComplemeto) {
            this.form.cidade = this.dadosGerais.dadosCliente.cidade;
            this.form.estado = this.dadosGerais.dadosCliente.estado;
          }

          const {data: _produtos} = await service.post(
            'Cotacao',
            'BuscaProdutosComplemento',
            this.form,
          );

          if (_produtos.length === 0) {
            this.nenhumProdutoEncontrado = true;
            this.$vs.loading.close();
            return;
          }

          const {produtosObrigatorios, produtosNaoObrigatorios} =
            this.formataProdutos(_produtos);

          this.form.produtosObrigatorios = produtosObrigatorios;
          this.form.produtosNaoObrigatorios = produtosNaoObrigatorios;

          this.form.dadosProdutosSelecionados = produtosObrigatorios;

          this.form.produtosSelecionados = produtosObrigatorios.reduce(
            (ids, item) => {
              ids.push(item.id_produto);
              return ids;
            },
            [],
          );

          this.produtos = _produtos;
          this.nenhumProdutoEncontrado = false;

          this.$forceUpdate();

          this.$vs.loading.close();
        }
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Falha ao buscar produtos',
          text: e,
          color: 'danger',
        });
      }
    },
    formataMoeda(valor) {
      return `R$ ${valor.toFixed(2)} `;
    },
    validaSelecionado(item) {
      const aux = this.form.dadosProdutosSelecionados.filter(
        (x) => x.id_produto == item.id_produto,
      );

      if (item.obrigatorio && aux.length > 0) return true;
      if (item.obrigatorio && aux.length == 0) return false;
    },

    uploadProductLink(productLinked, productId) {
      const product = this.form.dadosProdutosSelecionados.find(
        (item) => item.id_produto === productId,
      );
      const findIndex = this.form.dadosProdutosSelecionados.findIndex(
        (item) => item.id_produto === productLinked.id_produto,
      );
      if (findIndex === -1) {
        this.form.dadosProdutosSelecionados.push(productLinked);
        return;
      }

      if (!product) {
        this.form.dadosProdutosSelecionados.splice(findIndex, 1);
      }
    },

    overlappingProducts(productsIds) {
      this.form.dadosProdutosSelecionados =
        this.form.dadosProdutosSelecionados.filter(
          (productSelect) => !productsIds.includes(productSelect.id_produto),
        );
    },

    overProductsSelect(item) {
      this.produtos.forEach((product) => {
        const overlappingProducts = product.sobreporOutrosProdutos.split(',');
        if (overlappingProducts.includes(item.id_produto.toString())) {
          this.form.produtosSelecionados =
            this.form.produtosSelecionados.filter(
              (productSelected) => productSelected.id !== item.id_produto,
            );
        }
      });
    },

    overlappingProductsLinked(item) {
      const productsLinked = item.produtosLinkados.split(',').map(Number);
      productsLinked.forEach((productsId) => {
        const productLink = this.produtos.find(
          (product) => product.id_produto === productsId,
        );
        if (productLink) {
          this.uploadProductLink(productLink, item.id_produto);
        }
      });
    },

    overlappingProductsComplement(item) {
      const productsComplement = item.produtosComplementares
        .split(',')
        .map(Number);
      this.produto.forEach((product) => {
        if (productsComplement.includes(product.id_produto)) {
          product.exibir = !product.exibir;
        }
      });
      this.form.dadosProdutosSelecionados =
        this.form.dadosProdutosSelecionados.filter(
          (prod) =>
            !productsComplement.includes(prod.id_produto) || prod.exibir,
        );
    },

    selectProduct(item) {
      if (item.sobreporOutrosProdutos) {
        const overlappingProducts = item.sobreporOutrosProdutos
          .split(',')
          .map(Number);
        this.overlappingProducts(overlappingProducts);
      }

      this.buscaProdutosSobrepoeFaltante();

      if (item.produtosLinkados) {
        this.overlappingProductsLinked(item);
      }

      if (item.produtosComplementares) {
        this.overlappingProductsComplement(item);
      }

      this.$forceUpdate();
      this.somaValores();
    },
    obterProdutosFaltantes(produtosObrigatorios, produtosSelecionados) {
      return produtosObrigatorios.filter(
        (produtoObrigatorio) =>
          !produtosSelecionados.some(
            (produtoSelecionado) =>
              produtoSelecionado.id_produto === produtoObrigatorio.id_produto,
          ),
      );
    },
    podeSubstituirProduto(produtoSelecionado, idProdutoFaltante) {
      if (!produtoSelecionado.sobreporOutrosProdutos) return false;

      const produtosParaSubstituir =
        produtoSelecionado.sobreporOutrosProdutos.split(',');
      return produtosParaSubstituir.includes(idProdutoFaltante.toString());
    },
    buscaProdutosSobrepoeFaltante() {
      const produtosObrigatoriosFaltantes = this.obterProdutosFaltantes(
        this.form.produtosObrigatorios,
        this.form.dadosProdutosSelecionados,
      );

      if (produtosObrigatoriosFaltantes.length > 0) {
        produtosObrigatoriosFaltantes.forEach((produtoFaltante) => {
          const encontrouSubstituto = this.form.dadosProdutosSelecionados.some(
            (produtoSel) => {
              const produtoSelecionado = this.produtos.find(
                (produto) => produto.id_produto === produtoSel.id_produto,
              );
              return this.podeSubstituirProduto(
                produtoSelecionado,
                produtoFaltante.id_produto,
              );
            },
          );

          if (!encontrouSubstituto) {
            this.form.dadosProdutosSelecionados.push(produtoFaltante);
          }
        });
      }
    },
    calculaValor(item) {
      const descontoConcedido = Number(item.descontoConcedido);
      const porcentagemDescontoMaxima = Number(item.porcentagemDescontoMaxima);
      const itemValor = Number(item.valor);

      let valorFinal = 0;

      const descConcedMaiorQpercDescMax =
        descontoConcedido > porcentagemDescontoMaxima;
      if (descConcedMaiorQpercDescMax) {
        item.descontoConcedido = 0;

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Valor de Desconto excede ao valor Permitido',
          color: 'danger',
        });

        return;
      } else {
        valorFinal = itemValor - (itemValor * descontoConcedido) / 100;

        const produtosSelecionados = this.form.dadosProdutosSelecionados;
        produtosSelecionados.forEach((element) => {
          if (element.id_produto == item.id_produto) {
            element.valorFinal = valorFinal;
            element.descontoConcedido = descontoConcedido;
          }
        });
        this.form.dadosProdutosSelecionados = produtosSelecionados;

        item.descontoConcedido = descontoConcedido;
        item.valorFinal = valorFinal;

        this.filtraProdutosAtuais();

        this.$forceUpdate();
      }
    },
    somaValorTotalAtualizados(mensal = true) {
      let total = 0;
      if (this.form.dadosProdutosSelecionados)
        total = this.form.dadosProdutosSelecionados.reduce((acc, produto) => {
          if (produto.ismensal == mensal) acc += produto.valorFinal;
          return acc;
        }, 0);

      return total;
    },
    somaValorTotal(mensal = true) {
      let total = 0;

      if (this.dadosComplemento.produtosAgregado) {
        total = this.dadosComplemento.produtosAgregado.reduce(
          (acc, produto) => {
            if (produto.isMensal === mensal) acc += produto.valorFinal;
            return acc;
          },
          0,
        );
      }

      return total;
    },
    filtraProdutosAtuais() {
      if (!this.dadosComplemento.produtosAgregado) return;

      const obrigatorios = [];
      const opcionais = [];

      this.dadosComplemento.produtosAgregado.forEach((produto) => {
        if (produto.obrigatorio) {
          obrigatorios.push(produto);
          return;
        }
        opcionais.push(produto);
      });
      return {obrigatorios, opcionais};
    },
    verificaValor() {
      if (!this.editarComplemento) {
        this.$emit('update:valorCobertura', this.form.valorCobertura);
        this.form.atualizarProdutos = true;
        this.buscarProdutos();
        return;
      }
      this.form.atualizarProdutos = false;
    },
    selecionaStatusComplemento() {
      this.form.Status = this.statusComplementoSelecionado.label;
      this.form.idStatus = this.statusComplementoSelecionado.id;
    },
    async selecionaFormaPagamento() {
      this.form.idTipoPagamentoMensal = this.formaPagamentoSelecionada.id;

      if (this.form.atualizarProdutos && this.form.tipo == 'agregado') {
        this.form.produtos = this.produtos;
      } else {
        this.form.atualizarProdutos = false;
      }

      const {data: complemento} = await service.post(
        'Cotacao',
        'EditarComplemento',
        this.form,
      );

      const text = `Atualizado com sucesso ${complemento.tipo}`;
      this.$emit('atualizar', complemento);
      this.resetForm();

      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text,
        color: 'success',
      });
    },
    somaValores() {
      this.totalMensalidade = this.somaValorTotalAtualizados(true);

      if (this.produtos && this.produtos.length >= 0) {
        updateProdutoValorMensaliade(this.produtos, this.totalMensalidade);
        updateProdutoValorMinimoMensalidade(
          this.produtos,
          this.totalMensalidade,
        );
      }

      this.totalEntrada = this.somaValorTotalAtualizados(false);
    },
    generateLabel() {
      if (this.ativaMascarasVeiculos) {
        return this.tipoInicial === 'agregado'
          ? this.$t('Agregado', {msg: 'Agregado'})
          : this.$t('Implemento', {msg: 'Implemento'});
      }
      this.form.tipo = this.tipoComplemento;
      return this.form.tipo;
    },

    keymonitorPlaca: async function () {
      const permitirPlacaDuplicada =
        this.form.placa.length === 8 && this.permitePlacaDuplicada;
      if (permitirPlacaDuplicada) {
        return;
      }

      if (this.form.placa.length === 8) {
        this.$vs.loading();

        this.placaValidada = await this.consultarPlacaChassiBaseBP('placa');
        if (!this.placaValidada) {
          this.$vs.loading.close();
          return;
        }

        this.$vs.loading.close();
      }
    },
    async consultarPlacaChassiBaseBP(placa = null, chassi = null) {
      const isBP = functions.verificaEmpresaBemProtege(this.idEmpresa);

      if (!isBP || (!this.placaValidada && placa)) {
        return true;
      }

      const dadosConsultaPlaca = await buscarPlacaBaseBP({
        idEmpresa: this.idEmpresa,
        placa: placa ? this.form.placa : placa,
        chassi: chassi ? this.form.chassi : chassi,
      });

      if (dadosConsultaPlaca.codigoSituacao === '998') {
        if (
          !['Reativação', 'Troca de Titularidade'].includes(this.tipoProposta)
        ) {
          placa ? (this.form.placa = null) : (this.form.chassi = null);
          this.exibirAlertaPlaca(dadosConsultaPlaca);
          return false;
        } else {
          return true;
        }
      }

      this.codigoSituacaoPlaca = '0';
      return true;
    },
    exibirAlertaPlaca(dadosConsultaPlaca) {
      if (!dadosConsultaPlaca) return;

      const {
        nomeConsultorPlaca,
        regionalConsultorPlaca,
        modalPlacaRecusada,
        codigoSituacao,
      } = dadosConsultaPlaca;

      this.nomeConsultorPlaca = nomeConsultorPlaca;
      this.regionalConsultorPlaca = regionalConsultorPlaca;
      this.modalPlacaRecusada = modalPlacaRecusada;
      this.codigoSituacaoPlaca = codigoSituacao;
      this.situacaoPlaca =
        'Esta placa/chassi já existe em nosso banco de dados.';

      return;
    },

    verificaChassiBaseBP: async function () {
      if (this.form.chassi && this.form.chassi.length === 17) {
        this.$vs.loading();
        await this.consultarPlacaChassiBaseBP(null, 'chassi');
        this.$vs.loading.close();
      }
    },
    async getMarcaAgregadoImplemento() {
      try {
        this.$vs.loading();

        const marcas = await service.getAll(
          'Cotacao',
          {},
          'get-marca-agregado-implemento',
        );

        this.marcaAgregadoImplemento = marcas.data.map((marca) => ({
          value: marca.idMarcaAgregadoImplemento,
          label: marca.nome,
        }));
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `'Erro ao buscar marcas de ${this.$t('agregado', {msg: 'agregado'})} e ${this.$('agregado', {msg: 'agregado'})}`,
          color: 'danger',
          time: 3000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async getModeloAgregadoImplemento(marcaId) {
      try {
        this.$vs.loading();

        const modelos = await service.getAll(
          'Cotacao',
          {},
          `get-modelo-agregado-implemento/${marcaId}`,
        );

        this.modeloAgregadoImplemento = modelos.data.map((modelo) => ({
          value: modelo.idModeloAgregadoImplemento,
          label: modelo.nome,
        }));
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `'Erro ao buscar modelos de ${this.$t('agregado', {msg: 'agregado'})} e ${this.$('agregado', {msg: 'agregado'})}`,
          color: 'danger',
          time: 3000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    selecionaMarca() {
      this.form.modelo = null;
      this.modelo = null;

      this.form.marca = this.marca.label;
    },
    selecionaModelo() {
      this.form.modelo = this.modelo.label;
    },
    async preencheMarcaModelo() {
      const marcaSelecionada = this.marcaAgregadoImplemento.find(
        (marca) => marca.label === this.form.marca,
      );
      this.marca = marcaSelecionada;

      if (marcaSelecionada && marcaSelecionada.value) {
        await this.getModeloAgregadoImplemento(marcaSelecionada.value);

        const modeloSelecionado = this.modeloAgregadoImplemento.find(
          (modelo) => modelo.label === this.form.modelo,
        );
        this.modelo = modeloSelecionado;
      }
    },
    async buscaDadosEmpresa() {
      try {
        this.$vs.loading();
        const token = localStorage.getItem('user-token');
        const decoded = jwt.decode(token);
        const idEmpresa = decoded.id_empresa;

        const {data} = await service.getAll(
          'g',
          {},
          `empresas/list/idEmpresa/${idEmpresa}`,
        );
        const _data = decryptData(data);

        const [resultEmpresa] = _data;
        this.limiteAcessorioValue = resultEmpresa.limiteAcessorio;
        this.form.limiteAcessorio = `${resultEmpresa.limiteAcessorio} %`;
        this.aplicarRegraLimiteAcessorio =
          resultEmpresa.aplicarRegraLimiteAcessorio;
      } catch {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `'Erro ao buscar limite de acessório`,
          color: 'danger',
          time: 3000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    validaValorCobertura(newValue) {
      if (this.form.tipo === 'agregado' || !this.aplicarRegraLimiteAcessorio) {
        return;
      }
      const valorMaximo =
        this.form.fipeVeiculo * (this.limiteAcessorioValue / 100);

      if (newValue > valorMaximo) {
        this.form.valorCobertura = 0;
        this.$vs.notify({
          color: 'danger',
          title: 'Erro',
          time: 3000,
          text: `O valor informado excede o valor máximo de R$ ${valorMaximo.toFixed(
            2,
          )}.`,
        });
      }
    },
  },
  async mounted() {
    this.generateLabel();
    this.$validator.localize('ptBr', locale);
    await this.getMarcaAgregadoImplemento();
    await this.buscaDadosEmpresa();
  },
};
</script>
<style scoped lang="scss">
.vdp-datepicker input {
  width: 100%;
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 2px;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
